<template>
  <div>
    <!-- <el-table :data="list" style="width: 100%">
      <el-table-column label="优惠券名称">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="金额">
        <template slot-scope="scope">
          {{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column label="优惠券类型">
        <template slot-scope="scope">
          {{ scope.row.type | formatStat }}
        </template>
      </el-table-column>
      <el-table-column label="到期日">
        <template slot-scope="scope">
          {{ scope.row.endTime | formatTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="showSkip(scope.row)">
            立即使用
          </el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <template v-if="list && list.length > 0">
      <el-row :gutter="20" style="margin-right: 15px;margin-left: -5px" type="flex">
        <el-col v-for="(item, index) in list" :key="index" :span="8" class="couponCol">
          <el-card class="box-card" shadow="always" :body-style="{ padding: '0px' }">
            <div slot="header" class="header">
              {{ item.name }}
            </div>
            <div style="margin: 15px">
              <!-- <div><div class="card-label">优惠券名称</div><span>{{ item.name }}</span></div> -->
              <div><div class="card-label">面额</div><span>￥{{ item.amount }}</span></div>
              <div><div class="card-label">门槛</div><span>满{{ item.minPoint }}元可用</span></div>
              <div><div class="card-label">类型</div><span>{{ item.useType | formatUse }}</span></div>
              <div><div class="card-label">日期</div><span>{{ item.startTime | formatTime }} ~ {{ item.endTime | formatTime }}</span></div>
            </div>
            <div class="footer">
              <div v-if="status === 0" style="display: flex;align-items: center">
                <el-button type="text" style="color: #F5780C;" @click="showSkip(item)">立即使用</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </template>
    <template v-else><div style="text-align: center; font-size: 16px">暂无数据</div></template>
    <!-- 分页器 -->
    <div class="block" style="margin-top: 15px">
      <el-pagination
        :current-page="orderParam.pageNum"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="orderParam.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { fetchMemberCouponList } from '@/api/coupon.js'
import { mapMutations } from 'vuex'
export default {
  name: 'MyCoupon',
  filters: {
    formatUse(type) {
      if (type === 0) {
        return '全场通用'
      } else if (type === 1) {
        return '指定分类'
      } else if (type === 2) {
        return '指定商品'
      }
    },
    formatTime(time) {
      const dateString = time
      const date = new Date(dateString)
      const year = date.getFullYear()
      let month = date.getMonth() + 1 // getMonth() 返回的月份从0开始，所以需要+1
      let day = date.getDate()
      // let hour = date.getHours()
      // let minute = date.getMinutes()
      // let second = date.getSeconds()

      // 为了保持两位数，当小于10的时候，前面补0
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      // hour = hour < 10 ? '0' + hour : hour
      // minute = minute < 10 ? '0' + minute : minute
      // second = second < 10 ? '0' + second : second
      return `${year}-${month}-${day} ` // ${hour}:${minute}:${second}
    },
    formatPlatform(type) {
      if (type === 0) {
        return '全平台'
      } else if (type === 1) {
        return '移动'
      } else if (type === 2) {
        return 'pc商城端'
      }
    }
  },
  props: {
    status: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      list: [],
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      orderParam: {
        pageNum: 1,
        pageSize: 10
        // status: 6,
      }
    }
  },
  mounted() {
    this.getCouponCardList()
  },
  methods: {
    ...mapMutations(['SET_COUPONTAB0', 'SET_COUPONTAB1', 'SET_COUPONTAB2']),
    // 每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.orderParam.pageNum = 1
      this.orderParam.pageSize = val
      this.getCouponCardList()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.orderParam.pageNum = val
      this.getCouponCardList()
    },
    // 查询列表
    getCouponCardList() {
      const params = {
        pageNum: this.orderParam.pageNum,
        pageSize: this.orderParam.pageSize,
        useStatus: this.status
      }
      fetchMemberCouponList(params).then(res => {
        if (res.code === 200) {
          this.list = res.data.list
          this.total = res.data.total
          if (this.status === 0) {
            this.SET_COUPONTAB0(res.data.total)
          } else if (this.status === 1) {
            this.SET_COUPONTAB1(res.data.total)
          } else if (this.status === 2) {
            this.SET_COUPONTAB2(res.data.total)
          }
        } else {
          this.list = []
        }
      })
    },
    // 跳转商品
    showSkip(val) {
      console.log(val) // keyword productCategoryId categoryId brandId
      if (val.useType === 0) {
        this.$router.push({ path: '/goodsList', query: { keyword: '', couponId: val.id }})
      } else if (val.useType === 1) {
        this.$router.push({ path: '/goodsList', query: { productCategoryIds: val.productCategoryIds.toString(), couponId: val.id }})
      } else if (val.useType === 2) {
        this.$router.push({ path: '/goodsList', query: { productIds: val.productIds.toString(), couponId: val.id }})
      }
    }
  }
}
</script>
<style scoped>
.el-row {
  display:flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-row  .el-card {
  min-width: 100%;
  height: 100%;
  margin-right: 20px;
  transition: all .5s;
  font-size: 14px;
}
.el-form-item {
  margin-bottom: 0 !important;
}
.pagination-container {
  margin-top: -3px;
  margin-bottom: 30px;
}
.header{
  /* padding: 20px; */
}
.footer {
  font-size: 18px !important;
  background-color: rgb(245, 247, 251);
  display: flex;
  height: 50px;
  justify-content: space-evenly;
}
.card-label {
  color: rgb(197, 197, 197);
  margin-right: 8px;
  width: 80px;
  display: inline-block;
  margin-bottom: 5px;
}
.couponCol{
  margin-bottom: 20px;
}
</style>

